
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1503_NDialog extends Serenity.EntityDialog<Report_1503_NRow, any> {
        protected getFormKey() { return Report_1503_NForm.formKey; }
        protected getIdProperty() { return Report_1503_NRow.idProperty; }
        protected getLocalTextPrefix() { return Report_1503_NRow.localTextPrefix; }
        protected getNameProperty() { return Report_1503_NRow.nameProperty; }
        protected getService() { return Report_1503_NService.baseUrl; }
        protected getDeletePermission() { return Report_1503_NRow.deletePermission; }
        protected getInsertPermission() { return Report_1503_NRow.insertPermission; }
        protected getUpdatePermission() { return Report_1503_NRow.updatePermission; }

        protected form = new Report_1503_NForm(this.idPrefix);

    }
}